import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class EnvironmentService {
  private titleService = inject(Title);

  private static readonly AppName = 'ScreenDeck';

  applyTitle(): void {
    const label = environment.envLabel;
    const title = label
      ? `${label} ${EnvironmentService.AppName}`
      : EnvironmentService.AppName;

    this.titleService.setTitle(title);
  }
}
